import axios from 'axios';

import { getMicroservicesDomain, handleUnauthorizedError } from '../utils';
import {getDefaultHeaders} from "../utils/http";

const baseLaunchURL = `${getMicroservicesDomain()}/products/launch`;
const adminLaunchURL = `${getMicroservicesDomain()}/products/admin/launch`;
const uploadURL = `${getMicroservicesDomain()}/admin/assets`;


export async function getLaunchProducts() {
    const defaultHeaders = await getDefaultHeaders();
    const headers = { ...defaultHeaders };
    try {
        const { data } = await axios.get(baseLaunchURL, { headers });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        console.log('Failed to get launch products');
        return [];
    }
}

/**
 * @param {string} id The product ID
 */
export async function getLaunchProduct(id) {
    const url = `${baseLaunchURL}/${id}`;
    const defaultHeaders = await getDefaultHeaders();
    const headers = { ...defaultHeaders };
    try {
        const { data } = await axios.get(url, { headers });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        console.log(`Failed to get launch product for ID ${id}`);
        return null;
    }
}

export async function addLaunchProduct(product) {
    const defaultHeaders = await getDefaultHeaders();
    const headers = { ...defaultHeaders };
    try {
        const { data } = await axios.post(adminLaunchURL, product, { headers });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        console.log(`Failed to add launch product`);
        throw e;
    }
}

/**
 * @param {string} id The product ID
 */
export async function updateLaunchProduct(id, product) {
    const url = `${adminLaunchURL}/${id}`;
    const defaultHeaders = await getDefaultHeaders();
    const headers = { ...defaultHeaders };
    try {
        const { data } = await axios.put(url, product, { headers });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        console.log(`Failed to update launch product`);
        throw e;
    }
}

export async function deleteLaunchProduct(id) {
    const url = `${adminLaunchURL}/${id}`;
    const defaultHeaders = await getDefaultHeaders();
    const headers = { ...defaultHeaders };
    try {
        const { data } = await axios.delete(url, { headers });
        return data;
    } catch (e) {
        handleUnauthorizedError(e);
        console.log(`Failed to update launch product`);
        return null;
    }
}

export async function addLaunchProductAsset({ path, contentType, data }) {
    const defaultHeaders = await getDefaultHeaders();
    const headers = { ...defaultHeaders };

    const body = {
        meta: {
            path: `/launches/${path}`,
            contentType,
        },
        data,
    };

    try {
        const response = await axios.post(uploadURL, body, { headers });
        return response.data.URL;
    } catch (e) {
        handleUnauthorizedError(e);
        console.log('Failed to upload launch product image');
        console.log(e);
        return null;
    }
}
